import { useTranslation } from 'react-i18next'

import { SquaresFourIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import ActionsMenu from './ActionsMenu/ActionsMenu'
import * as Styles from './styles'

const VisibilityCriterionItem = ({ criterion, index, isEditable, onEdit, onDuplicate, onDelete }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.MainContainer index={index}>
      <Styles.PositionContainer>
        <Text type="bodyMBold">#{criterion.internal_id}</Text>
      </Styles.PositionContainer>
      <Styles.ContentContainer>
        <Styles.Header>
          <Styles.HeaderLeft>
            <Text type="bodyMBold">{criterion.name}</Text>
            <Chip
              label={t('Usado en {{count}} bloques', { count: criterion.block_uids.length })}
              Icon={SquaresFourIcon}
              backgroundColor={theme.colors.info.surface}
              color={theme.colors.info.onSurface}
            />
          </Styles.HeaderLeft>
          <ActionsMenu
            criterion={criterion}
            isEditable={isEditable}
            onEdit={onEdit}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
          />
        </Styles.Header>
        {criterion.description && (
          <Styles.Description>
            <Text type="bodyMRegular">{criterion.description}</Text>
          </Styles.Description>
        )}
      </Styles.ContentContainer>
    </Styles.MainContainer>
  )
}

export default VisibilityCriterionItem
